<template>
    <div>
        <Card dis-hover>
            <Form ref="queryForm" :label-width="90" label-position="right" inline>
                <Row>
                    <Col span="3">
                        <FormItem label="姓名:" :label-width="70" style="width: 100%">
                            <Input v-model="params.Name" placeholder="请输入姓名"></Input>
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <FormItem label="公司:" :label-width="70" style="width: 100%">
                            <Input v-model="params.CompanyName" placeholder="请输入公司"></Input>
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <FormItem label="城市:" :label-width="70" style="width: 100%">
                            <Input v-model="params.City" placeholder="请输入城市"></Input>
                            <!-- <Cascader :data="cities" v-model="params.city"></Cascader> -->
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <FormItem label="电话:" :label-width="70" style="width: 100%">
                            <Input v-model="params.PhoneNumber" placeholder="请输入电话"></Input>
                        </FormItem>
                    </Col>
                    <!-- <Col span="3">
                        <FormItem label="内部:" :label-width="70" style="width: 100%">
                            <Select v-model="params.IsOutside">
                                <Option :value="null">--</Option>
                                <Option :value="1">是</Option>
                                <Option :value="0">否</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
                    <Col span="5">
                        <Button icon="ios-search" type="primary" size="default" @click="queryTab" class="toolbar-btn">{{ '查询' }}</Button>
                        <Button @click="addSupper" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '添加' }}</Button>
                    </Col>
                </Row>
            </Form>
            <!-- <Table row-key="id" :columns="columns" :data="data" border></Table> -->
            <div>
                <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
                <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount" :current="currentPage"></Page>
            </div>
            <QRCode :value="modalShow" @close="closeQR" :id="itemId" v-if="modalShow && itemId" />
            <NewOutPerson :value="createShow" :nameItems="nameItems" :isAdd="isAdd" @close="close" :uid="itemId" @getTab="getTab" />
        </Card>
    </div>
</template>
<script>
import QRCode from './QRCode.vue';
import { getOutPerson, removeOutPerson, getAfterPerson } from '../../../../api/index';
import NewOutPerson from './newoutperson.vue';

export default {
    components: {
        QRCode,
        NewOutPerson,
    },
    mounted() {
        this.getTab();
        this.getColumns();
        // this.getAfterPerson();
    },
    data() {
        return {
            list: [],
            itemId: 0,
            totalCount: 0,
            loading: false,
            createShow: false,
            isAdd: true,
            modalShow: false,
            currentPage: 1,
            nameItems: [],
            params: {
                Name: '',
                City: '',
                CompanyName: '',
                PhoneNumber: '',
                IncludeCreatoUser: true,
                SkipCount: 0,
                MaxResultCount: 10,
            },
            columns: [],
            data: [],
        };
    },
    methods: {
        //获取所有内部售后人员
        // async getAfterPerson() {
        //     const data = await getAfterPerson();
        //     console.log('🚀 ~ file: aftersale.vue:164 ~ getAfterPerson ~ data', data);
        //     this.nameItems = data.data.result.userData;
        // },
        getColumns() {
            let _this = this;
            this.columns = [
                {
                    title: '姓名',
                    key: 'name',
                },
                // {
                //     title: '内部/外部',
                //     // key: 'isInteriorChange',
                //     render: (h, params) => {
                //         return h('span', !params.row.isOutside ? '内部' : '外部');
                //     },
                // },
                {
                    title: '公司名称',
                    key: 'companyName',
                },

                {
                    title: '电话',
                    key: 'phoneNumber',
                },
                {
                    title: '城市',
                    key: 'city',
                },
                 {
                    title: '微信绑定openID',
                    key: 'wxOpenId',
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 260,
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: async () => {
                                            _this.itemId = params.row.id;
                                            _this.modalShow = true;
                                        },
                                    },
                                },
                                '绑定微信二维码'
                            ),
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            console.log(params);
                                            _this.itemId = params.row.id;
                                            _this.isAdd = false;
                                            _this.createShow = true;
                                        },
                                    },
                                },
                                '编辑'
                            ),
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                    },
                                    on: {
                                        click: async () => {
                                            this.$Modal.confirm({
                                                title: '确定删除数据？',
                                                content: '删除后不可撤销',
                                                okText: '确认',
                                                cancelText: '取消',
                                                onOk: async () => {
                                                    let res = await removeOutPerson(params.row.id);
                                                    if (res.data.success) {
                                                        this.$Message.success('删除成功');
                                                    } else {
                                                        this.$Message.success('删除失败');
                                                    }
                                                    this.getTab();
                                                },
                                            });
                                        },
                                    },
                                },
                                '删除'
                            ),
                        ]);
                    },
                },
            ];
        },
        //获取表格数据
        async getTab() {
            const data = await getOutPerson(this.params);
            this.list = data.data.result.items;
            this.totalCount = data.data.result.totalCount;
        },
        //查询
        queryTab() {
            this.params.SkipCount = 0;
            this.currentPage = 1;
            this.$nextTick(() => {});
            this.getTab();
        },
        addSupper() {
            this.isAdd = true;
            this.createShow = true;
        },
        //分页
        pageChange(size) {
            this.params.SkipCount = (size - 1) * this.params.MaxResultCount;
            this.getTab();
        },
        pagesizeChange(size) {
            this.params.MaxResultCount = size;
            this.getTab();
        },
        //关闭弹框
        close() {
            this.createShow = false;
        },
        closeQR(val) {
            this.modalShow = val;
        },
    },
};
</script>
